export default __webpack_public_path__ + "static/nano_horz_color-8f657ca97b45676f55c5752118c43fa5.webp";